import type { ReactNode } from "react";

export type DiagramFrameTreatment =
  | { kind: "none" }
  | {
      kind: "boundary";
      label: string;
      x?: number;
      y?: number;
      width?: number;
      height?: number;
    };

export type DiagramFrameProps = {
  width: number;
  height: number;
  title: string;
  titleId: string;
  descId: string;
  description: string;
  viewBox: string;
  frame: DiagramFrameTreatment;
  children: ReactNode;
};

export function DiagramFrame({
  width,
  height,
  title,
  titleId,
  descId,
  description,
  viewBox,
  frame,
  children,
}: DiagramFrameProps) {
  const boundary = frame.kind === "boundary" ? frame : undefined;
  return (
    <div
      className="w-full overflow-hidden select-none font-sans outline-none rounded-xl"
      tabIndex={0}
    >
      <svg
        viewBox={viewBox}
        className="w-full h-auto text-ga-ink"
        role="img"
        aria-labelledby={`${titleId} ${descId}`}
      >
        <title id={titleId}>{title}</title>
        <desc id={descId}>{description}</desc>

        {boundary && (
          <>
            <rect
              x={boundary.x ?? 20}
              y={boundary.y ?? 20}
              width={boundary.width ?? width}
              height={boundary.height ?? height}
              rx="12"
              fill="none"
              stroke="var(--ga-brass, #9c6b3e)"
              strokeWidth="1"
              strokeDasharray="8 6"
              opacity="0.38"
            />
            <g
              transform={`translate(${(boundary.x ?? 20) + 8}, ${(boundary.y ?? 20) - 8})`}
            >
              <text
                fill="var(--ga-brass, #9c6b3e)"
                className="font-mono text-[11px] font-bold tracking-widest uppercase"
              >
                {boundary.label}
              </text>
            </g>
          </>
        )}

        {children}
      </svg>
    </div>
  );
}
